import {
    getEstAndMaxReviewTimes,
    getSafe,
    MaxReviewTime,
    PendingResponse,
    VerificationService,
} from '@sheerid/jslib';
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { PENDING_REDIRECT } from '../../constants';
import { redirect } from '../../lib/utils/browser';

interface ReviewPendingProps {
    intl: any;
    verificationService: VerificationService;
    // eslint-disable-next-line
    maxReviewTime?: MaxReviewTime; // deprecated
}

export const timesChanged = (previousResponse: PendingResponse, currentResponse: PendingResponse) => {
    const previousEst = getSafe(() => previousResponse.estimatedReviewTime);
    const previousMax = getSafe(() => previousResponse.maxReviewTime);
    const newEst = getSafe(() => currentResponse.estimatedReviewTime);
    const newMax = getSafe(() => currentResponse.maxReviewTime);
    return (previousEst !== undefined && previousEst !== newEst) || (previousMax !== undefined && previousMax !== newMax);
};

const ReviewPending = ({ intl, verificationService }: ReviewPendingProps) => {
    const verificationResponse: PendingResponse = (verificationService.verificationResponse as PendingResponse);
    const [isAlerting, setAlertState] = React.useState(false);
    const redirectDestination = PENDING_REDIRECT;

    if (!isAlerting && timesChanged(verificationService.previousVerificationResponse as PendingResponse, verificationResponse)) {
        setAlertState(true);
    }

    const estAndMaxTimes = getEstAndMaxReviewTimes({ ...verificationResponse }, verificationService.programTheme, intl);

    return (
        <div className="sid-header" data-testid="sid-review-pending">
            <div className="sid-header__title sid-l-space-top-md">
                <FormattedHTMLMessage id="step.pending.titleReview" defaultMessage="Reviewing" />
            </div>
            <div className="sid-header__subtitle-one">
                <FormattedHTMLMessage
                    id="step.pending.subtitleAlt"
                    defaultMessage="SheerID is reviewing your documents, to confirm your status."
                />
            </div>
            <div className="sid-header__subtitle-two sid-l-space-top-md">
                <FormattedHTMLMessage
                    id="step.pending.turnaroundTime"
                    defaultMessage="turnaround time is typically {estReviewTime} and in rare times of high volume, may take up to {maxReviewTime}"
                    values={estAndMaxTimes}
                />
            </div>
            <div className="sid-header__subtitle-one">
                <FormattedHTMLMessage
                    id="step.pending.subtitle2"
                    defaultMessage="Wait here or let us notify you of the outcome."
                />
            </div>
            <div className="sid-header__subtitle-one">
                <FormattedHTMLMessage
                    id="step.pending.subtitle3"
                    defaultMessage="You will be contacted via email."
                />
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.pending.redirectButtonText" defaultMessage="Use code now" />
                </button>
            </div>

            {
                isAlerting
                    ? (
                        <div className="sid-pending-red-box">
                            <ul>
                                <li><FormattedHTMLMessage id="step.pending.docDiffLang" defaultMessage="We identified your document is in a different language." /></li>
                                <li>
                                    <FormattedHTMLMessage
                                        id="step.pending.turnaroundTime"
                                        defaultMessage="Turnaround time for your language is typically {estReviewTime}, and in rare times of high volume may take up to {maxReviewTime}."
                                        values={estAndMaxTimes}
                                    />
                                </li>
                            </ul>
                        </div>
                    )
                    : null
            }
            <div className="sid-l-space-top-md" />
        </div>
    );
};
export const ReviewPendingComponent = ReviewPending;
